import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/** @jsx jsx */
import { jsx } from '@theme-ui/core';
import { cloneElement } from 'react';
import { IconUiErrorFilled } from '../../';
import { AlertSimpleBase } from './alert-simple-base';
function AlertSimpleError(_ref) {
  var icon = _ref.icon,
    props = _objectWithoutProperties(_ref, ["icon"]);
  var iconStyles = {
    color: 'state.error'
  };
  return jsx(AlertSimpleBase, _extends({
    icon: icon ? ( /*#__PURE__*/cloneElement(icon, {
      sx: {
        iconStyles: iconStyles
      }
    })) : jsx(IconUiErrorFilled, {
      size: "xsmall",
      sx: iconStyles
    }),
    sx: {
      color: 'red.dark'
    }
  }, props));
}
export { AlertSimpleError };